import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { token } from "../theme/tokens.js";
export function GalleryEmptyState({ icon, title, description, action }) {
    const containerStyle = {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "64px 24px",
        textAlign: "center",
        width: "100%",
    };
    const iconStyle = {
        fontSize: "48px",
        marginBottom: "16px",
        opacity: 0.5,
    };
    const titleStyle = {
        margin: "0 0 8px 0",
        fontSize: "18px",
        fontWeight: 600,
        color: token("titleColor"),
    };
    const descStyle = {
        margin: "0 0 24px 0",
        fontSize: "14px",
        color: token("metaColor"),
        maxWidth: "360px",
    };
    // No role: an empty collection is the rendered state of the collection
    // itself, not a live announcement about it. role="status" made screen
    // readers report "No drawings yet" as an update when it is simply what the
    // region contains. See docs/designs/message-taxonomy.md § 7.1.
    return (_jsxs("div", { style: containerStyle, children: [icon && _jsx("div", { style: iconStyle, children: icon }), _jsx("h3", { style: titleStyle, children: title }), description && _jsx("p", { style: descStyle, children: description }), action && _jsx("div", { children: action })] }));
}
//# sourceMappingURL=GalleryEmptyState.js.map